import { Component, HostListener, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-genre-slider",
  templateUrl: "./genre-slider.component.html",
  styleUrls: ["./genre-slider.component.css"],
})
export class GenreSliderComponent implements OnInit {
  reloadSlider = true;
  genereContent: any = [];
  isLoding = true;
  array = [];
  appConstants: any;
  constructor(
    public service: BaseService,
    public translate: TranslateService
  ) {}
  isDragging: boolean;

  ngOnInit(): void {
    this.appConstants = environment;
    this.getGenereData();
  }
  generCarousel: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 1.3,
      },
      375: {
        items: 2.3,
      },
      425: {
        items: 2.2,
      },
      575: {
        items: 4.3,
      },
      786: {
        items: 4.3,
      },
      991: {
        items: 5.3,
      },
      1366: {
        items: 5.3,
      },
      1500: {
        items: 5.3,
      },
    },
    nav: true,
  };

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.reloadSlider = false;
    setTimeout(() => {
      this.reloadSlider = true;
    }, 10);
  }

  getGenereData() {
    let index = -1;
    let localData = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    if (localData) {
      index = localData
        .map((el) => {
          return el.hasOwnProperty("genres");
        })
        .indexOf(true);
    } else {
      localData = [];
    }
    if (index != -1) {
      this.service.genresData = true;
      this.genereContent = localData[index]["genres"].results;
      this.isLoding = false;
    } else {
      const count = true;
      this.service.genereDataService(count).subscribe(
        (res) => {
          if (res.results.length > 0) {
            this.service.genresData = true;
            this.genereContent = res.results;
            // this.genrePosition();
            localData.push({ ["genres"]: res });
            localStorage.setItem(
              environment.pagesLocalStorageKey,
              JSON.stringify(localData)
            );

            this.isLoding = false;
          } else {
            this.isLoding = false;
            this.service.genresData = false;
          }
        },
        (err) => {
          if (err) {
            setTimeout(() => {
              this.isLoding = false;
              this.service.genresData = false;
            }, 3000);
          }
        }
      );
    }
  }
  genrePosition() {
    for (let j = 0; j < this.genereContent.length; j++) {
      if (j % 2 === 0) {
        this.array.push({ data: this.genereContent[j] });
      } else {
        const i = this.array.length - 1;
        this.array[i].dataOne = this.genereContent[j];
      }
    }
  }
}
